import { COLORS as DefaultColors } from "../sub/theme/colors";
import { COLORS as AppColors } from "../constants/colors";

export const COLORS = { ...DefaultColors, ...AppColors };
